export default __webpack_public_path__ + "approved-icon-dark.svg";